import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">六大分类，满足您的多样化观影需求</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 hover:bg-background-50 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors text-sm">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}